import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import moment from "moment";
import { isEmpty, startCase } from "lodash";

import CustomDatePicker from "../../components/CustomDatePicker";
import ProfitLossReportModal from "./ProfitLossReportModal";
import MyAccountFilter from "../MyAccount/MyAccountFilter";
import { apiGet } from "../../Utils/apiFetch";
import { apiPath } from "../../Utils/apiPath";
import { formatDate, toFixedWithoutRounding } from "../../Utils/Constant";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";

const eventTypeLabel = (eventType) =>
  eventType === "4"
    ? "Cricket"
    : eventType === "1"
      ? "Soccer"
      : eventType === "2"
        ? "Tennis"
        : "";

const ReportByEvent = () => {
  const params = useParams();
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const tableRef = useRef();

  const previousDate = moment()
    .subtract(1, "day")
    .format("YYYY-MM-DD HH:mm:ss");
  const currentDate = moment().format("YYYY-MM-DD HH:mm:ss");

  const DEFAULT_FILTER = {
    page: 1,
    limit: 10,
    fromPeriod: previousDate,
    toPeriod: currentDate,
    filterByDay: "",
    created_by: params?.id || user?._id,
    userType: params?.user_type || user?.userType,
    eventType: "all",
    keyword: "",
  };
  const [detailsData, setDetailsData] = useState([]);
  const [filter, setFilter] = useState(DEFAULT_FILTER);
  const [data, setData] = useState([]);
  const [show, setShow] = useState(false);
  const [openEventIds, setOpenEventIds] = useState([]);
  const [matchBetsData, setMatchBetsData] = useState({});
  const requestSeq = useRef(0);

  const getData = async (activeFilter) => {
    setOpenEventIds([]);
    setMatchBetsData({});
    setData([]);

    const seq = ++requestSeq.current;
    const { status, data: response_users } = await apiGet(
      apiPath.reportMatch,
      activeFilter,
    );
    if (seq !== requestSeq.current) return;
    if (status === 200 && response_users.success) {
      const rows = response_users.results?.data || [];
      setData(rows);
    }
  };

  useEffect(() => {
    getData(filter);
  }, [filter.page, filter.limit]);

  const applyPreset = (preset) => {
    const nextFilter = { ...filter, page: 1, filterByDay: preset };
    if (preset === "today") {
      nextFilter.fromPeriod = moment()
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
      nextFilter.toPeriod = moment().endOf("day").format("YYYY-MM-DD HH:mm:ss");
    } else if (preset === "yesterday") {
      nextFilter.fromPeriod = moment()
        .subtract(1, "day")
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
      nextFilter.toPeriod = moment()
        .subtract(1, "day")
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
    }
    setFilter(nextFilter);
    if (filter.page === nextFilter.page) getData(nextFilter);
  };

  const handleLimitChange = (e) =>
    setFilter((prev) => ({ ...prev, limit: Number(e.target.value), page: 1 }));

  const handleSportChange = (e) => {
    const nextFilter = { ...filter, page: 1, eventType: e.target.value };
    setFilter(nextFilter);
    if (filter.page === nextFilter.page) getData(nextFilter);
  };
  const openMarket = (item) => {
    setDetailsData(item);
    setShow(true);
  };

  const toggleEvent = async (item) => {
    // local open/close is keyed on the row's _id, but the API is still
    // called with eventId
    const id = item?._id;
    if (openEventIds.includes(id)) {
      setOpenEventIds((prev) => prev.filter((x) => x !== id));
      setMatchBetsData((prev) => {
        const next = { ...prev };
        delete next[id];
        return next;
      });
      return;
    }
    setOpenEventIds((prev) => [...prev, id]);
    const { status, data: response_users } = await apiGet(apiPath.matchBet, {
      eventId: item.eventId,
    });
    if (status === 200 && response_users.success) {
      setMatchBetsData((prev) => ({
        ...prev,
        [id]: response_users.results?.data || [],
      }));
    }
  };

  const plSpan = (value) =>
    value ? (
      Math.sign(value) === -1 ? (
        <span className="red">({toFixedWithoutRounding(Math.abs(value))})</span>
      ) : (
        <span>{toFixedWithoutRounding(Math.abs(value))}</span>
      )
    ) : (
      "0.00"
    );

  // belt-and-braces: filter client-side too, in case apiPath.reportMatch
  // doesn't actually honor the eventType param server-side
  const visibleData =
    filter.eventType === "all"
      ? data
      : data.filter(
          (item) => String(item?.eventType) === String(filter.eventType),
        );

  const finalPnl = visibleData.reduce((a, v) => a + Number(v?.amount || 0), 0);

  const totalRecords = visibleData?.length || 0;

  return (
    <app-pl-market className="ng-star-inserted">
      <div className="main_wrap">
        <div className="box">
          <h2>Profit/Loss Report by Event</h2>
        </div>

        <div className="function-wrap">
          <ul className="input-list flowroot">
            <li>
              <label>Sports</label>
            </li>
            <li>
              <select
                id="func_sports"
                value={filter.eventType}
                onChange={handleSportChange}
              >
                <option value={"all"}>All</option>
                <option value="1">SOCCER</option>
                <option value="2">TENNIS</option>
                <option value="4">CRICKET</option>
                <option value="-1">CASINO</option>
              </select>
            </li>
            <li />
            <li>
              <input
                type="text"
                placeholder="search"
                value={filter.keyword}
                onChange={(e) =>
                  setFilter((prev) => ({ ...prev, keyword: e.target.value }))
                }
              />
            </li>
            <li>
              <label>Period</label>
            </li>
            <CustomDatePicker filter={filter} setFilter={setFilter} />
          </ul>
          <ul className="input-list flowroot">
            <li>
              <a
                id="today"
                className="btn"
                onClick={(e) => {
                  e.preventDefault();
                  applyPreset("today");
                }}
              >
                Just for today
              </a>
            </li>
            <li>
              <a
                id="yesterday"
                className="btn"
                onClick={(e) => {
                  e.preventDefault();
                  applyPreset("yesterday");
                }}
              >
                From yesterday
              </a>
            </li>
            <li>
              <a
                id="getPL"
                className="btn-send"
                onClick={(e) => {
                  e.preventDefault();
                  getData(filter);
                }}
              >
                Get P &amp; L
              </a>
            </li>
          </ul>
        </div>

        <div className="total_all">
          <span>
            <label>Last:</label>
            <select
              name="limit"
              id="limit"
              value={filter.limit}
              onChange={handleLimitChange}
            >
            <option value={10}>10 Txn</option>{" "}
              <option value={25}>25 Txn</option>{" "}
              <option value={50}>50 Txn</option>
              <option value={100}>100 Txn</option>
            </select>
          </span>
          <div className="spacer" />
          <span className="total-users" style={{ fontWeight: "600" }}>
            {" "}
            Total Records: {totalRecords}{" "}
          </span>
          <MyAccountFilter
            type={"new"}
            tableRef={tableRef}
            fileName="report-event"
          />
        </div>

        <div
          id="reportDiv"
          className="over-wrap"
          style={{ maxHeight: "calc(100% - 32px - 93px)" }}
        >
          <div className="table-responsive data-table">
            <table ref={tableRef} id="table_DL" className="table01 table-pt">
              <tbody>
                <tr id="head">
                  <th id="header_eventName" className="align-L sort_asc">
                    Event
                  </th>
                  <th width="18%" className="align-L sort_asc">
                    Competition
                  </th>
                  <th width="15%" className="sort_asc">
                    Stake
                  </th>
                  <th width="15%" className="sort_asc">
                    {" "}
                    Player P/L
                  </th>
                  <th
                    id="header_profitLoss_downLine"
                    width="15%"
                    className="sort_asc"
                  >
                    {" "}
                    Downline P/L{" "}
                  </th>
                  <th
                    id="header_tax_agent_3"
                    width="15%"
                    style={{ display: "none" }}
                  >
                    {" "}
                    Master Comm.{" "}
                  </th>
                  <th
                    id="header_rebate_agent_3"
                    width="15%"
                    style={{ display: "none" }}
                  >
                    {" "}
                    Master Rebate{" "}
                  </th>
                  <th id="header_tax_agent_2" width="15%" className="sort_asc">
                    Super Comm.
                  </th>
                  <th
                    id="header_rebate_agent_2"
                    width="15%"
                    style={{ display: "none" }}
                  >
                    {" "}
                    Super Rebate{" "}
                  </th>
                  <th
                    id="header_payout_agent_1"
                    width="15%"
                    style={{ display: "none" }}
                  >
                    {" "}
                    SS PT{" "}
                  </th>
                  <th
                    id="header_tax_agent_1"
                    width="15%"
                    style={{ display: "none" }}
                  >
                    {" "}
                    SS Comm.{" "}
                  </th>
                  <th
                    id="header_rebate_agent_1"
                    width="15%"
                    style={{ display: "none" }}
                  >
                    {" "}
                    SS Rebate{" "}
                  </th>
                  <th
                    id="header_profitLoss_agent_1"
                    width="15%"
                    style={{ display: "none" }}
                  >
                    {" "}
                    SS Total{" "}
                  </th>
                  <th width="15%" className="sort_asc">
                    {" "}
                    Upline P/L
                  </th>
                </tr>
              </tbody>

              <tbody id="content">
                {!isEmpty(visibleData) ? (
                  visibleData.map((item, index) => {
                    const isOpen = openEventIds.includes(item?._id);
                    const subBets = matchBetsData[item?._id] || [];
                    return (
                      <React.Fragment key={item?.eventId || index}>
                        <tr id={`main_${item?.eventId || index}`}>
                          <td
                            style={{ paddingLeft: "7px" }}
                            className="align-L"
                          >
                            <a
                              style={{ margin: "0", cursor: "pointer" }}
                              id="_byMarket"
                              className={
                                isOpen ? "expand-close" : "expand-open"
                              }
                              onClick={() => toggleEvent(item)}
                            />
                            <a href="#">
                              <span id="_eventType">
                                {eventTypeLabel(item?.eventType)}
                              </span>
                              <img
                                src="/assets/images/transparent.gif"
                                className="fromto"
                                alt=""
                              />
                              <strong id="_eventName">{item?.matchName}</strong>
                            </a>
                          </td>
                          <td className="align-L" style={{ fontWeight: "600" }}>
                            {item?.seriesName || "-"}
                          </td>
                          <td id="_stake">
                            {" "}
                            {toFixedWithoutRounding(item?.stake || 0)}{" "}
                          </td>
                          <td id="_profitLoss">{plSpan(item?.amount)}</td>
                          <td>{plSpan(item?.amount)}</td>
                          <td id="_tax3" style={{ display: "none" }}>
                            0.00
                          </td>
                          <td id="_rebate3" style={{ display: "none" }}>
                            0.00
                          </td>
                          <td id="_tax2">
                            <span>0.00</span>
                          </td>
                          <td id="_rebate2" style={{ display: "none" }}>
                            0.00
                          </td>
                          <td id="_payout1" style={{ display: "none" }}>
                            0.00
                          </td>
                          <td id="_tax1" style={{ display: "none" }}>
                            0.00
                          </td>
                          <td id="_rebate1" style={{ display: "none" }}>
                            0.00
                          </td>
                          <td id="_profitLoss1" style={{ display: "none" }}>
                            0.00
                          </td>
                          <td id="_profitLossUpLine">
                            {plSpan(-(item?.amount || 0))}
                          </td>
                        </tr>

                        {isOpen &&
                          subBets.map((sub, i) => (
                            <tr
                              className="expand first"
                              style={{ display: "table-row" }}
                              key={i}
                              id={`sub_${item?.eventId}_${i}`}
                            >
                              <td className="align-L">
                                <a
                                  onClick={(e) => {
                                    e.preventDefault();
                                    openMarket(sub);
                                  }}
                                  id="_sportName"
                                  className="ico_account"
                                >
                                  {sub?.market || startCase(sub?.runnerName)}
                                </a>
                              </td>
                              <td />
                              <td id="sport_stake">
                                {" "}
                                {toFixedWithoutRounding(sub?.stake || 0)}{" "}
                              </td>
                              <td id="sport_profitLoss">
                                {plSpan(sub?.amount)}
                              </td>
                              <td id="sport_profitLossDownLine">
                                {plSpan(sub?.amount)}
                              </td>
                              <td id="sport_tax3" style={{ display: "none" }}>
                                0.00
                              </td>
                              <td
                                id="sport_rebate3"
                                style={{ display: "none" }}
                              >
                                0.00
                              </td>
                              <td id="sport_tax2">
                                <span> 0.00 </span>
                              </td>
                              <td
                                id="sport_rebate2"
                                style={{ display: "none" }}
                              >
                                0.00
                              </td>
                              <td
                                id="sport_payout1"
                                style={{ display: "none" }}
                              >
                                0.00
                              </td>
                              <td id="sport_tax1" style={{ display: "none" }}>
                                0.00
                              </td>
                              <td
                                id="sport_rebate1"
                                style={{ display: "none" }}
                              >
                                0.00
                              </td>
                              <td
                                id="sport_profitLoss1"
                                style={{ display: "none" }}
                              >
                                0.00
                              </td>
                              <td id="sport_profitLossUpLine">
                                {plSpan(-(sub?.amount || 0))}
                              </td>
                            </tr>
                          ))}
                      </React.Fragment>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={14}>You have no bets in this time period.</td>
                  </tr>
                )}

                {!isEmpty(visibleData) && (
                  <tr className="total">
                    <td className="align-L">Total</td>
                    <td />
                    <td id="_totalStake">
                      <span> - </span>
                    </td>
                    <td id="_totalProfitLoss">{plSpan(finalPnl)}</td>
                    <td id="_totalProfitLossDownLine">{plSpan(finalPnl)}</td>
                    <td id="_totalTax3" style={{ display: "none" }}>
                      0.00
                    </td>
                    <td id="_totalRebate3" style={{ display: "none" }}>
                      0.00
                    </td>
                    <td id="_totalTax2">
                      <span> 0.00 </span>
                    </td>
                    <td id="_totalRebate2" style={{ display: "none" }}>
                      0.00
                    </td>
                    <td id="_totalPayout1" style={{ display: "none" }}>
                      0.00
                    </td>
                    <td id="_totalTax1" style={{ display: "none" }}>
                      0.00
                    </td>
                    <td id="_totalRebate1" style={{ display: "none" }}>
                      0.00
                    </td>
                    <td id="_totalProfitLoss1" style={{ display: "none" }}>
                      0.00
                    </td>
                    <td id="_totalProfitLossUpLine">{plSpan(-finalPnl)}</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <ProfitLossReportModal
        isOpen={show}
        onClose={() => setShow(false)}
        item={detailsData}
        parentFilter={filter}
      />
    </app-pl-market>
  );
};

export default ReportByEvent;
